import React, { useState, useRef, useEffect } from "react";
import Button from "./Button";
import { Icons } from "../assets/icons/Icons";
import CryptoDropdown from "./CryptoDropdown";
import AddressInput from "./AddressInput";
import NetworkDropdown from "./NetworkDropdown";
import { useFunds } from "../service";

export const WithDraw = () => {
  const divRef = useRef(null);
  const [address, setAddress] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [otherAddress, setOtherAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [errors, setErrors] = useState({
    address: false,
    otherAddress: false,
    amount: false,
    acceptedTerms: false,
  });
  const [selectedCrypto, setSelectedCrypto] = useState("");
  const [selectedNetwork, setSelectedNetwork] = useState("");

  const { withdrawFunds } = useFunds();

  useEffect(() => {
    const preventScroll = (event) => {
      event.preventDefault();
    };

    const div = divRef.current;
    if (div) {
      div.addEventListener("wheel", preventScroll, { passive: false });
    }

    return () => {
      if (div) {
        div.removeEventListener("wheel", preventScroll);
      }
    };
  }, []);
  const handleWithdraw = () => {
    let newErrors = {
      address: !address,
      otherAddress: !otherAddress,
      amount: !amount,
      acceptedTerms: !acceptedTerms,
    };

    setErrors(newErrors);
    if (newErrors.idNumber || newErrors.amount || newErrors.acceptedTerms) {
      return;
    }

    withdrawFunds.mutate(idNumber, amount);
    setIdNumber("0");
    setAmount("0");
    setAccepted(false);
    setAcceptedTerms(false);
    ModalClose();
  };

  const ModalClose = () => {
    const modalCloseButton = document.querySelector("#menu-request .btn-close");
    if (modalCloseButton) {
      modalCloseButton.click();
    }
  };
  const handleInputChange = (setter, field) => (e) => {
    setter(e.target.value);
    setErrors((prev) => ({ ...prev, [field]: false }));
  };
  const handleCheckboxChange = (e) => {
    setAccepted(e.target.checked);
    setAcceptedTerms(e.target.checked);
    setErrors((prev) => ({ ...prev, accepted: false }));
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const handleOtherAddresstChange = (newAmount) => {
    setOtherAddress(newAmount);
  };
  const handleCryptoSelect = (crypto) => {
    setSelectedCrypto(crypto);
    console.log("Selected crypto:", crypto);
  };
  const handleNetworkSelect = (network) => {
    setSelectedNetwork(network);
    console.log("Selected network:", network);
  };
  return (
    <div
      ref={divRef}
      className="offcanvas offcanvas-top rounded-m"
      id="menu-request"
      style={{
        height: "100vh",
        background: "#141414",
        padding: "30px 18px",
        width: "100%",
        overflowY: "hidden",
        zIndex: "9999",
        backgroundImage: "url('./images/store/notification_bg.png')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0px 0px",
        backgroundSize: "contain",
        backgroundColor: "#000000",
      }}
    >
      <div className="offcanvas-header">
        <button
          type="button"
          className="btn-close opacity-1"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          style={{ display: "none" }}
        ></button>

        <div onClick={ModalClose} style={{ cursor: "pointer" }}>
          <Icons.BackWithBG />
        </div>
        <h2 className="font-33 font-700" style={{ marginLeft: "12px" }}>
          Withdraw Funds
        </h2>
      </div>
      <div style={{ paddingTop: "20px" }}>
        <CryptoDropdown label="CHOOSE CRYPTO" onSelect={handleCryptoSelect} />

        <NetworkDropdown
          label="CHOOSE NETWORK"
          onSelect={handleNetworkSelect}
          id={selectedCrypto?.id ?? "btc"}
        />

        <AddressInput
          type="address"
          label="YOUR ADRESS"
          placeholder="Adress"
          value={amount}
          onChange={handleAddressChange}
        />

        <AddressInput
          type="address"
          label="ADRESS"
          placeholder="Adress"
          value={address}
          onChange={handleInputChange(setAmount, "amount")}
        />

        <div
          style={{
            position: "absolute",
            bottom: "25px",
          }}
        >
          <div
            className="form-check mt-3 mb-3"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <input
              className={`form-check-input ${
                errors.accepted ? "border-danger" : ""
              }`}
              type="checkbox"
              checked={accepted}
              onChange={handleCheckboxChange}
              style={{ marginTop: "6px" }}
            />
            <label
              className="font-13 font-500"
              style={{ color: "#C3C4FF", paddingLeft: "7px" }}
            >
              I Accept The Treams Of Service
            </label>
          </div>
          <div className="text-center" style={{ width: "342px" }}>
            <Button onClick={handleWithdraw}>WithDraw Funds</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
